<div class="knowledge-archive-container" *ngIf="!isLoadingArchive && !isLoadingLabels">
	<div class="kb-info-col" *ngIf="loggedUserView">
		<div class="title">{{ labels.lbl_geral_cmdb_kb }}</div>
		<div class="title">
			<span>ID {{ kbArchive.id }}</span>
			<div
				class="point-relevance"
				[ngClass]="{
					bad: (kbArchive.points / kbArchive.points_vote_qtd) * 25 <= 40,
					ok: (kbArchive.points / kbArchive.points_vote_qtd) * 25 <= 60,
					good: (kbArchive.points / kbArchive.points_vote_qtd) * 25 > 60,
				}"
				*ngIf="kbArchive.points && kbArchive.points_vote_qtd">
				{{ parseInt((kbArchive.points / kbArchive.points_vote_qtd) * 25) }}%
			</div>
			<div class="point-relevance" *ngIf="!kbArchive.points || !kbArchive.points_vote_qtd">{{ labels.lbl_nao_avaliado }}</div>
		</div>

		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_versao }}: </span> <span>{{ kbArchive.version }}</span>
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_kb_pontos }}: </span> <span>{{ kbArchive.points ? kbArchive.points : '0' }}</span>
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_data }}: </span> <span>{{ DateService.formatDate(kbArchive.version_date.toString()) }}</span>
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_idioma }}: </span> <span>{{ kbArchive.language }}</span>
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_status }}: </span>
			<span>{{ kbArchive.status ? kbArchive.status : labels.lbl_asset_nao_possui }}</span>
		</div>

		<span class="mb-2">{{ labels.lbl_geral_avaliar }}:</span>
		<div class="vote-container">
			<span
				class="star"
				[ngClass]="{ voted: voteValue >= 1, 'not-voted': voteValue != 0 && voteValue < 1 }"
				[title]="'_Não foi útil'"
				(click)="evaluateArchive(1)"
				><fa-icon [icon]="icons.faStar"></fa-icon
			></span>
			<span
				class="star"
				[ngClass]="{ voted: voteValue >= 2, 'not-voted': voteValue != 0 && voteValue < 2 }"
				[title]="'_Pouco útil'"
				(click)="evaluateArchive(2)"
				><fa-icon [icon]="icons.faStar"></fa-icon
			></span>
			<span
				class="star"
				[ngClass]="{ voted: voteValue >= 3, 'not-voted': voteValue != 0 && voteValue < 3 }"
				[title]="'_Bem útil'"
				(click)="evaluateArchive(3)"
				><fa-icon [icon]="icons.faStar"></fa-icon
			></span>
			<span
				class="star"
				[ngClass]="{ voted: voteValue >= 4, 'not-voted': voteValue != 0 && voteValue < 4 }"
				[title]="'_Muito útil'"
				(click)="evaluateArchive(4)"
				><fa-icon [icon]="icons.faStar"></fa-icon
			></span>
		</div>

		<div>
			<span>{{ labels.lbl_leave_a_comment }}:</span>
		</div>
		<textarea [rows]="3" [value]="commentary" (input)="commentary = $event.target.value"></textarea>

		<div class="button-container">
			<div class="button" [ngClass]="{ disabled: isSendingCommentary }" (click)="sendCommentary()">
				{{ labels.lbl_geral_enviar }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isSendingCommentary"></cpi-dot-bounce-loading-effect>
			</div>
		</div>

		<div class="button-container" *ngIf="ProfileService.userData().idAnalyst && userView == 1">
			<div class="button" (click)="redirectTo('/knowledgebase/' + kbArchive.id)">{{ labels.lbl_security_gerenciar }}</div>
		</div>

		<div class="know-solution-container" *ngIf="userView == 0 && idRequest">
			<span>{{ labels.lbl_artigo_resolveu_chamado }} {{ idRequest }}?</span>
			<div class="button-container">
				<div class="button" (click)="putRequestSolvedByKb(idRequest)">{{ labels.lbl_geral_sim }}</div>
				<div class="button" (click)="redirectTo('/request/' + idRequest)">{{ labels.lbl_geral_nao }}</div>
			</div>
		</div>
	</div>

	<div class="kb-content-col">
		<div class="header" *ngIf="!loggedUserView">
			<div class="logos"><img src="assets/images/Atos.svg" /></div>
			<div class="button-container">
				<div class="button" (click)="redirectTo('/login')">{{ labels.lbl_geral_voltar }}</div>
			</div>
		</div>
		<div class="kb-content-container">
			<ng-container *ngIf="showingLine === ''">
				<div (click)="showingLine = 'summary'">
					<span>{{ labels.lbl_geral_summary }}</span> <span [innerHtml]="kbArchive.summary"></span>
				</div>
				<div (click)="showingLine = 'description'">
					<span>{{ labels.lbl_geral_detalhamento }}</span> <span [innerHtml]="kbArchive.description"></span>
				</div>
			</ng-container>

			<ng-container *ngIf="showingLine !== ''">
				<div class="header" (click)="showingLine = ''">
					<fa-icon [icon]="icons.faArrowLeft"></fa-icon>&nbsp;
					{{
						showingLine === 'summary'
							? labels.lbl_geral_summary
							: showingLine === 'description'
								? labels.lbl_geral_detalhamento
								: showingLine === 'cause'
									? labels.lbl_status_analise_causa
									: showingLine === 'resolution'
										? labels.lbl_asset_resolucao
										: labels.lbl_kb_aplica_se
					}}
				</div>
				<div class="body" [innerHtml]="kbArchive[showingLine]"></div>
			</ng-container>
		</div>
	</div>
</div>

<!-- Aparece ao estar carregando a página -->
<div class="loading-container" *ngIf="isLoadingArchive || isLoadingLabels || archiveNotFound" #loadingMesoContainer>
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ archiveNotFound ? labels.lbl_nothing_was_found : labels.lbl_edocs_carregando }}!</div>
	<div class="button-container" *ngIf="!loggedUserView && archiveNotFound">
		<div class="button" (click)="redirectTo('/login')">{{ labels.lbl_geral_voltar }}</div>
	</div>
</div>
